// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06d12eb3","389":"0fb02808","732":"b9ca9c42","977":"8686ab96"}[chunkId] + ".chunk.js";
};